import React, {useState} from 'react';

import {hooks} from '../hooks';
import {Routes} from '../routes';
import {svg} from '../assets/svg';
import {SonsType} from '../types';
import {components} from '../components';
import {actions} from '../store/actions';

export const DetailSons: React.FC = () => {
  const navigate = hooks.useNavigate();
  const dispatch = hooks.useDispatch();
  const location = hooks.useLocation();

  const son: SonsType = location.state.son;

  const [opacity, setOpacity] = useState<number>(0);

  hooks.useScrollToTop();
  hooks.useOpacity(setOpacity);
  hooks.useThemeColor('#F6F9F9', '#F6F9F9', dispatch);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        showBasket={true}
        title='My Child'
      />
    );
  };

  const renderImage = (): JSX.Element => {
    return (
      <section style={{position: 'relative', marginBottom: 15}}>
        <img
          src={son.banner}
          alt={son.name}
          style={{
            width: '100%',
            objectFit: 'cover',
            maxHeight: 300,
            objectPosition: 'top center'
          }}
        />
      </section>
    );
  };

  const renderDetails = (): JSX.Element => {
    return (
      <section>
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: 10, paddingTop: 8, paddingBottom: 15, gap: 15}}>
          <span onClick={() => navigate(`/detail-sons/detail-sons-absensi/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/absensi-icon-white.png" alt="Absensi Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Absensi</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-rkh/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/rkh-icon-white.png" alt="RKH Icon" />
            <p className='t10' style={{textAlign: 'center'}}>RKH</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-raport/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/raport-icon-white.png" alt="Raport Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Raport</p>
          </span>
          <span onClick={() => navigate(`/detail-sons/detail-sons-subjects/${son.id}`, {state: {son}})}>
            <img style={{maxWidth: 50, padding: 10, borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}} className='clickable' src="/assets/img-icon/study-icon-white.png" alt="Study Icon" />
            <p className='t10' style={{textAlign: 'center'}}>Subjects</p>
          </span>
        </div>
      </section>
    );
  };

  const renderButton = (): JSX.Element => {
    return (
      <components.Button
        text='Edit Profile'
        onClick={() => {
          navigate(Routes.Checkout);
        }}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
      <main className='scrollable' style={{paddingTop: 10, paddingBottom: 20}}>
        {renderImage()}
        <ul className='container'>
          <li
           style={{
            padding: '0 12px',
            borderRadius: 10,
            position: 'relative',
            marginBottom: 15,
            display: 'flex',
            alignItems: 'flex-start',
            gap: 16,
          }}>
            <div
              style={{
                width: '100%',
              }}
            >
              {renderDetails()}
              <section style={{minWidth: 140, padding: 20, borderRadius: 6, border: '1px solid var(--main-turquoise)'}}>
                <div className='row-center-space-between' style={{marginBottom: 10}}>
                  <p
                    className='t10'
                    style={{lineHeight: 1.2}}
                  >
                    Ananda
                  </p>
                  <p
                    className='t12'
                    style={{lineHeight: 1.2}}
                  >
                    {son.description}
                  </p>
                </div>
                <div className='row-center-space-between' style={{marginBottom: 10, padding: 10, backgroundColor: 'rgb(232 245 225)',borderRadius: 6, color: 'var(--main-turquoise)'}}>
                  <h4>{son.name}</h4>
                  <span 
                    onClick={() => navigate(`/detail-sons/detail-sons-grade-analysis/${son.id}`, {state: {son}})} 
                    style={{width:'100%', maxWidth: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 6, border: '1px solid var(--border-color)', backgroundColor: 'var(--main-turquoise)'}}>
                    <img style={{width: 38, padding: '7px 10px 7px 0'}}  className='clickable' src="/assets/img-icon/chart-white.png" alt="chart Icon"/>
                    <p className='t10' style={{textAlign: 'center', color: 'white', lineHeight: 1.2}}>Grade <br /> Analysis</p>
                  </span>
                </div>
                <ul style={{padding: 10}}>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>NISN</p>
                    <h5 style={{paddingLeft: 8}}>{son.nisn}</h5>
                  </li>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>Birth Place</p>
                    <h5 style={{paddingLeft: 8}}>{son.birthPlace}</h5>
                  </li>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>Birth Date</p>
                    <h5 style={{paddingLeft: 8}}>{son.birthDate}</h5>
                  </li>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>Handphone</p>
                    <h5 style={{paddingLeft: 8}}>{son.handphone}</h5>
                  </li>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>Citizenship</p>
                    <h5 style={{paddingLeft: 8}}>{son.citizenship}</h5>
                  </li>
                  <li style={{marginBottom: 12}}>
                    <p className='t10' style={{textAlign: 'left'}}>Religion</p>
                    <h5 style={{paddingLeft: 8}}>{son.religion}</h5>
                  </li>
                </ul>
              </section>
              <div style={{paddingTop: 10}}>
                {renderButton()}
              </div>
            </div>
          </li>
        </ul>
      </main>
      </>
    );
  };

  const renderFooter = (): JSX.Element => {
    return <components.Footer />;
  };

  return (
    <div
      id='screen'
      style={{opacity}}
    >
      {renderHeader()}
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
